import { downloadBlobFromApi, printBlobFromApi } from '../../helpers'
import apiService from '../Api'
import {
  EstablishmentAttendeesResponse,
  EstablishmentOrder,
  EstablishmentOrderStatus,
  EstablishmentOrdersResponse,
  EstablishmentSalesSummary
} from './types'

/**
 * Vendas de estabelecimentos no evento (ABRA-317): relatório, lista de vendas, exportação e
 * cancelamento. Os celulares que vendem são pareados em Maquininhas e se vinculam pelo app.
 */
export class EventEstablishmentService {
  async getSummary(eventId: number): Promise<EstablishmentSalesSummary> {
    return apiService.get(`/events/${eventId}/establishments/summary`).then((res) => res.data)
  }

  async getOrders(
    eventId: number,
    params: {
      establishment_id?: number
      status?: EstablishmentOrderStatus
      search?: string
      page?: number
      page_size?: number
    }
  ): Promise<EstablishmentOrdersResponse> {
    return apiService.get(`/events/${eventId}/establishments/orders`, { params }).then((res) => res.data)
  }

  /** ABRA-399 — os inscritos de cada oficina, sem as vendas canceladas. */
  async getAttendees(eventId: number): Promise<EstablishmentAttendeesResponse> {
    return apiService.get(`/events/${eventId}/establishments/attendees`).then((res) => res.data)
  }

  /** Lista de presença das oficinas (PDF): com `productId`, só aquela oficina; sem, todas as que têm inscritos. */
  async printAttendanceList(eventId: number, productId?: number): Promise<void> {
    const query = productId ? `?product_id=${productId}` : ''
    return printBlobFromApi(`/events/${eventId}/establishments/attendance-pdf${query}`)
  }

  async cancelOrder(eventId: number, orderId: number): Promise<EstablishmentOrder> {
    return apiService.post(`/events/${eventId}/establishment-orders/${orderId}/cancel`).then((res) => res.data.data)
  }

  async downloadXlsx(eventId: number, eventSlug: string): Promise<void> {
    return downloadBlobFromApi(`/events/${eventId}/establishments/export-xlsx`, `vendas_parceiros_${eventSlug}.xlsx`)
  }
}
